exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".microphone[data-v-576a6d17]{display:block;width:16px;height:16px;margin:auto;text-decoration:none}\n", ""]);
